// axios
import axios from "axios";
import VueCookies from "vue-cookies";

const baseURL = process.env.VUE_APP_API_URL;

const instance = axios.create({
	baseURL: baseURL,
	headers: {
		"Content-Type": "application/json"
	}
});

/*
 * The backend requires a credential on every write (POST/PUT/PATCH/DELETE)
 * and on /cron/*. The dashboard uses the JWT it received from POST /users/login,
 * stored by Login.vue in the "nid" cookie. Nothing secret lives in this repo:
 * the token is issued and verified by the backend only.
 */
instance.interceptors.request.use((config) => {
	const token = VueCookies.get("nid");
	if (token) config.headers.Authorization = `Bearer ${token}`;
	return config;
});

/*
 * A 401 on a request that carried a token means the token expired (24 h) or
 * was rejected: clear the session and return to the login page, the same
 * cookies ProfileDropDown.logout() removes. A 401 without a token is left to
 * the caller (login itself, password reset).
 */
instance.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error && error.response && error.response.status;
		const sentToken = error && error.config && error.config.headers && error.config.headers.Authorization;
		if (status === 401 && sentToken && !window.location.pathname.startsWith("/login")) {
			["nid", "kb", "aspi", "userInfo"].forEach((name) => VueCookies.remove(name));
			window.location.assign("/login");
		}
		return Promise.reject(error);
	}
);

export default instance;
